// External dependencies
import classnames from "classnames";

// Define the types for margin and padding props
interface SpacingProps {
  sm?: number | string;
  mt?: number | string;
  mb?: number | string;
  ml?: number | string;
  mr?: number | string;
  m?: number | string;
  pt?: number | string;
  pb?: number | string;
  pl?: number | string;
  pr?: number | string;
  p?: number | string;
}

// Generate margin classes based on props
export const generateMarginClasses = ({
  mt,
  mb,
  ml,
  mr,
  m
}: SpacingProps) => {
  return classnames({
    [`mt-${mt}`]: mt !== undefined,
    [`mb-${mb}`]: mb !== undefined,
    [`ml-${ml}`]: ml !== undefined,
    [`mr-${mr}`]: mr !== undefined,
    [`m-${m}`]: m !== undefined,
  });
};

// Generate padding classes based on props
export const generatePaddingClasses = ({
  pt,
  pb,
  pl,
  pr,
  p
}: SpacingProps) => {
  return classnames({
    [`pt-${pt}`]: pt !== undefined,
    [`pb-${pb}`]: pb !== undefined,
    [`pl-${pl}`]: pl !== undefined,
    [`pr-${pr}`]: pr !== undefined,
    [`p-${p}`]: p !== undefined,
  });
};
